<template>
  <v-container>
    <v-row>
      <v-col class="pl-0">
        <validation-provider
          v-slot="{ errors }"
          :name="resourceLabel"
          rules="decimal:2"
        >
          <v-text-field
            v-model="amount"
            :error-messages="errors"
            :label="$t(resourceLabel)"
            :clearable="clearable"
          ></v-text-field>
        </validation-provider>
      </v-col>

      <v-col class="pr-0">
        <validation-provider
          v-slot="{ errors }"
          :name="resourceLabel"
          :rules="`${(amount !== null && amount.length > 0) ? 'required' : ''}`"
        >
          <CurrencyField
            v-model="currency"
            :label="$t('common.currency')"
            :error-messages="errors" />
        </validation-provider>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CurrencyField from "@/components/fields/CurrencyField.vue";
import utils from "@/utils";

/*
 * nodel input value format:
 *   { amount, currency }
 */
export default {
  name: "AmountField",
  components: { CurrencyField },

  props: {
    value: {
      type: Object
    },
    resourceLabel: {
      type: String,
      mandatory: true
    },
    rounded: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array,
      default: () => []
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      select: null,
      amount: null,
      currency: null
    };
  },

  methods: {
    filter(item, queryText) {
      const text = item.firstName.toLowerCase() + " " + item.lastName.toLowerCase();
      return text.indexOf(queryText.toLowerCase()) > -1;
    },

    emitValue() {
      this.$emit("input", {
        amount: (this.amount !== null && this.amount.length > 0) ? utils.toNumber(this.amount) : null,
        currency: this.currency || null
      });
    },

    setValue(value) {
      if (value !== null) {
        if (value.amount !== null)
          this.amount = value.amount.toString().replace(".", ",");
        else
          this.amount = null;

        if (value.currency !== null && value.currency.length > 0)
          this.currency = value.currency;
        else
          this.currency = null;
      } else {
        this.amount = null;
        this.currency = null;
      }
    }
  },

  watch: {
    value: function() {
      this.setValue(this.value);
    },

    select: function() {
      this.$emit("input", this.select);
    },

    amount: function() {
      this.emitValue();
    },

    currency: function() {
      this.emitValue();
    }
  },

  mounted() {
    this.setValue(this.value);
  }
};
</script>

<style scoped>

</style>